import React, { useEffect, useState, useRef } from 'react';
import './App.less';
import { useLocation } from 'react-router-dom';
import RC from './components/redeem-code/index';
import BaseButton from './components/base-button';
import FixedButton from './components/fixed-button';
import BaseImage from './components/base-image';
import Discount from './components/discount';
import BaseLogin from './components/base-login';
import { Modal, Toast } from 'antd-mobile';
import { inApp, isFunction, callHandlerClose, getUrlByParam } from '@hst/utils';
import { marketingApi } from 'src/api';
import { connect } from 'react-redux';
import { setUserInfo } from 'src/store/common/actions';
import { toNativeActionsButtonsShare } from 'src/utils/share';
import { useTranslation } from 'react-i18next';
import { isHK, isMY } from 'src/config/env';
import { getShareMetaDefault } from 'src/config/share';
import { trackActivityPageShow, trackActivityPageView } from './track';
import { goLogin } from 'src/utils/jump';
import { mergeAdjacentNewsItems } from 'src/utils/common.js';
import customReportErr from 'src/utils/sentry';
import { serializeError } from 'serialize-error';
import ImageText from './components/image-text';
import BaseText from './components/base-text';
import StockCard from './components/stock-card';
import News from './components/news';

interface PageData {
	html: {
		compId: string;
		compType: string;
		subs: any;
		values: {
			textColor?: string; // 字体颜色
			textBackgroundColor?: string; // 字体背景颜色
			textDesc: string;
			textTitle: string; // 文本组件标题
			useDefaultTitleStyle?: 1 | 0; // 文本组件是否使用默认样式
			backgroundImg: string; // 背景图片
			backGroundColor: string; //背景颜色
			btnName?: string; // 按钮名称
			btnText?: string; // 按钮文案
			btnImg: string; // 按钮图片
			jumpLink?: number; // 跳转类型 1 下载/唤起APP 2 H5链接 3 原生链接 4 新版原生链接
			jumpLinkStr?: string; // 原生跳转LINK
			jumpPosition?: string; // H5跳转链接
			jumpParam?: string; // 原生跳转参数
			jumpLinkStrNew?: string; // 新的原生跳转LINK
			jumpParamNew?: string; // 新的原生跳转参数
			name: string; //卡券组件名称
			rewardItems: {
				value: string;
				label: string;
				key: string;
			}[]; //卡券奖励id
		};
	}[];
	data: {
		allBackgroundColor?: string;
	};
	status: number;
}
const Marketing = (props) => {
	const { t, i18n } = useTranslation();
	const searchParams = new URLSearchParams(useLocation().search);
	const [pageData, setPageData] = useState<PageData>({ html: [], data: {}, status: 1 });
	const pageStatus = useRef<string>('normal');
	const isLogin = useRef(false);
	const [isVerifyPassed, setIsVerifyPassed] = useState<boolean>(false);
	const [fixBtnHeight, setFixBtnHeight] = useState(0);
	const pageId = searchParams.get('id') || '';
	const _scnl = searchParams.get('_scnl') || '';
	const type = searchParams.get('type') || '';
	const model = searchParams.get('model') || '';

	const dialogTip = (tip, btnText = t('ok'), handleAction?: () => void) => {
		Modal.show({
			content: tip,
			className: 'marketing-modal',
			closeOnAction: true,
			actions:
				inApp() || handleAction
					? [
							{
								key: 'comfirm',
								text: btnText,
							},
						]
					: [],
			onAction: () => {
				if (isFunction(handleAction)) {
					handleAction();
				} else {
					callHandlerClose();
				}
			},
		});
	};

	// 获取活动信息
	const getActivityInfo = (activityId) => {
		if (!activityId) {
			setIsVerifyPassed(true);
			return;
		}
		return marketingApi
			.getActivityInfo({
				activityId,
			})
			.then((res) => {
				const { success, data, msg } = res;
				if (success) {
					if (new Date(data?.currTime).getTime() < new Date(data?.startTime).getTime()) {
						pageStatus.current = 'disabled';
						dialogTip(t('notStart'));
						return;
					}
					if (
						new Date(data?.currTime).getTime() >= new Date(data?.endTime).getTime() ||
						!data?.isOnline
					) {
						pageStatus.current = 'disabled';
						dialogTip(t('isEnd'));
					}
					setIsVerifyPassed(true);
				} else {
					Toast.show({
						content: msg || t('tooHot'),
					});
					customReportErr('获取活动信息1', JSON.stringify(res));
				}
			})
			.catch((err) => {
				// dialogTip(t('networkErr'));
				customReportErr('获取活动信息2', serializeError(err));
				console.log(err);
			});
	};

	// 获取活动限制
	const getActivityLimit = async (activityId) => {
		try {
			let res;
			if (isHK) {
				res = await marketingApi.getPageAccessControl({
					pageId,
					pageLang: i18n.language,
				});
			} else if (activityId && isLogin.current) {
				res = await marketingApi.getActivityLimit({
					activityId,
				});
			}
			if (res) {
				const { success, data, msg, code } = res;
				if (success) {
					if (!data && !isHK) {
						pageStatus.current = 'disabled';
						dialogTip(t('mismatch'));
					}
				} else {
					pageStatus.current = 'disabled';
					dialogTip(code === 25073102 ? t('mismatch') : msg || t('tooHot'));
					customReportErr('获取活动限制1', JSON.stringify(res));
				}
			}
		} catch (error) {
			// dialogTip(t('networkErr'));
			customReportErr('获取活动限制2', serializeError(error));
			console.log(error);
		}
	};

	// 获取登录状态
	const getAccountStatus = async () => {
		const { success, data } = await marketingApi.getAccountStatus({
			buzz: { withAC: true },
		});
		if (success) {
			isLogin.current = !!data.logined;
			props.setUserInfo(data);
			if (data.logined) {
				trackActivityPageView(pageId);
			}
		}
	};

	const initOrUpdateShare = (data) => {
		const { defaultShareTitle, defaultShareDesc, defaultShareImg } = getShareMetaDefault(t);
		const shareImg = data.shareImg || defaultShareImg;
		const shareDesc = data.shareDesc || defaultShareDesc;
		const shareTitle = data.shareTitle || defaultShareTitle;
		const shareLink = getUrlByParam(window.location.href, {
			ref: 'share',
		});
		if (inApp()) {
			// app 分享
			const shareOptions = {
				wxTimelineDescMode: false,
				link: shareLink,
				image: shareImg,
				title: shareTitle || '',
				desc: shareDesc || '',
			};
			toNativeActionsButtonsShare(shareOptions);
		}
	};

	const initPageInfo = async () => {
		// @ts-ignore
		const pageData = window__initialData__;
		const { html, data, status, defaultLang = '', pageLang = [] } = pageData;
		let hasLoginComponent = false;
		if (!pageLang?.includes(i18n.language)) {
			i18n.changeLanguage(defaultLang);
		}
		pageData.html = html?.map((item) => {
			item.values = data?.[item.compId] || {};
			item.base.attrs = item?.base?.attrs?.concat(item?.style?.attrs);
			if (item.compType === 'login_my') hasLoginComponent = true;
			return item;
		});
		pageData.html = mergeAdjacentNewsItems(pageData.html);
		setPageData(pageData);
		initOrUpdateShare(data);
		console.log(pageData);
		if (type === 'preview') {
			setIsVerifyPassed(true);
			return;
		}
		await getAccountStatus();
		// 马来app内未登录用户跳原生登录页面
		if (hasLoginComponent && isMY && inApp() && !isLogin.current) {
			goLogin({ lang: i18n.language, _scnl });
		}
		// 1 下线 2 上线
		if (status === 1) {
			// 判断页面是否在线
			pageStatus.current = 'disabled';
			dialogTip(t('notAccess'));
		} else if (model === 'page') {
			// 判断是否需要限制IP 不限制: 1 仅限大陆：2 仅限香港及海外地区：3
			const ipAccessRestriction = String(data.ipAccessRestriction);
			if (data.accessControl && ipAccessRestriction && ipAccessRestriction !== '1') {
				// 需要执行 IP 限制检查
				const { ipLimitMiddleware } = await import('src/utils/ipLimit');
				const canAccess = await ipLimitMiddleware(ipAccessRestriction);
				if (!canAccess) {
					// IP 被限制，结束执行
					return;
				}
			}
			// 判断是否需要登录
			if (
				data.accessControl &&
				data.accessControl?.accessLoginRequire === '1' &&
				!isLogin.current
			) {
				pageStatus.current = 'disabled';
				dialogTip(t('notLogin'), t('goLogin'), () => {
					goLogin({ lang: i18n.language, _scnl });
				});
				return;
			}
			// 判断活动状态是否正常
			await getActivityLimit(data?.activityId);
			if (pageStatus.current !== 'disabled') {
				// 判断是否在活动时间内
				getActivityInfo(data?.activityId);
			}
		}
	};

	const handleHeightChange = (height) => {
		setFixBtnHeight(height);
	};

	useEffect(() => {
		trackActivityPageShow(pageId);
		initPageInfo();
		if ('scrollRestoration' in history) {
			history.scrollRestoration = 'manual';
		}
		// 滚动条定位到卡券位置
		const scrollTop = sessionStorage.getItem('scrollTop');
		const pageHeight = sessionStorage.getItem('pageHeight');
		document.body.style.height = `${pageHeight}px`;
		window.scrollTo(0, scrollTop ? Number(scrollTop) : 0);
		setTimeout(() => {
			sessionStorage.setItem('scrollTop', '0');
			sessionStorage.setItem('pageHeight', 'auto');
		}, 200);
	}, []);

	return (
		<div>
			{(pageData?.status !== 1 || type === 'preview') && (
				<div className='marketing' style={{ background: pageData?.data?.allBackgroundColor }}>
					<div className='marketing-content'>
						{pageData?.html.map((item) => {
							const { compType, values, compId } = item;
							if (compType === 'base_btn') {
								return (
									<BaseButton
										key={item.compId}
										data={values}
										pageStatus={pageStatus.current}
										compType={compType}
										compId={compId}
									/>
								);
							} else if (compType === 'fixed_btn') {
								return (
									<FixedButton
										key={item.compId}
										data={values}
										pageStatus={pageStatus.current}
										compType={compType}
										compId={compId}
										onHeightChange={handleHeightChange}
									/>
								);
							} else if (compType === 'base_img' || compType === 'hot_area') {
								return (
									<BaseImage key={item.compId} data={values} pageStatus={pageStatus.current} />
								);
							} else if (compType === 'discount') {
								return <Discount key={item.compId} data={values} isVerifyPassed={isVerifyPassed} />;
							} else if (compType === 'base_text') {
								return (
									<BaseText data={values} pageStatus={pageStatus.current} />
									// <div key={item.compId}>
									// 	<div
									// 		className='co-terms'
									// 		style={{
									// 			color: values?.textColor,
									// 			backgroundColor: values?.textBackgroundColor,
									// 		}}>
									// 		<p>{values.textDesc}</p>
									// 	</div>
									// </div>
								);
							} else if (compType === 'redeem_code') {
								return <RC data={values} />;
							} else if (
								compType === 'login_my' &&
								!(inApp() || props?.userInfo?.logined || pageStatus.current === 'disabled')
							) {
								return <BaseLogin key={item.compId} data={values} />;
							} else if (compType === 'img_text') {
								return <ImageText data={values} pageStatus={pageStatus.current} />;
							} else if (compType === 'stock') {
								return <StockCard data={values} />;
							} else if (compType === 'newsList') {
								return <News data={item.subs} pageStatus={pageStatus.current} />;
							}
						})}
					</div>
					<div style={{ height: `${fixBtnHeight}px` }}></div>
				</div>
			)}
		</div>
	);
};
const mapStateToProps = (state) => ({
	userInfo: state.common.userInfo,
});
const mapDispatchToProps = {
	setUserInfo,
};

export default connect(mapStateToProps, mapDispatchToProps)(Marketing);
